export const buildCompanyLocationURL = (companyId: number, locationId: number): string => `/crm/companies/${companyId}/locations?ptv=id=l_${locationId}`;
export const buildCompanySpaceURL = (companyId: number, spaceId: number): string => `/crm/companies/${companyId}/locations?ptv=id=s_${spaceId}`;
